import React from 'react'

export const CloseIcon = ({ variant, size }) => {
  if (variant === 'redSmall') {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0009 13.0607L7.28859 17.7729L6.22794 16.7123L10.9402 12L6.22794 7.28769L7.2886 6.22703L12.0009 10.9393L16.7132 6.22703L17.7738 7.28769L13.0616 12L17.7738 16.7123L16.7132 17.7729L12.0009 13.0607Z"
          fill="#E36F1E"
        />
      </svg>
    )
  } else if (variant === 'white') {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.05692 7.99997L3.52832 4.47137L4.47113 3.52856L7.99972 7.05716L11.5283 3.52856L12.4711 4.47137L8.94253 7.99997L12.4711 11.5286L11.5283 12.4714L7.99972 8.94278L4.47113 12.4714L3.52832 11.5286L7.05692 7.99997Z"
          fill="white"
        />
      </svg>
    )
  } else {
    return (
      <svg
        width={size ? size : '32'}
        height={size ? size : '32'}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0009 13.0607L7.28859 17.7729L6.22794 16.7123L10.9402 12L6.22794 7.28769L7.2886 6.22703L12.0009 10.9393L16.7132 6.22703L17.7738 7.28769L13.0616 12L17.7738 16.7123L16.7132 17.7729L12.0009 13.0607Z"
          fill="black"
        />
      </svg>
    )
  }
}
